'use client';

export interface ClientProperties {
  userAgent: string;
  screenHeight: number;
  screenWidth: number;
  currentUrl: string;
  referrer: string;
  referringDomain: string;
  language: string;
  utm: {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmContent?: string;
    utmTerm?: string;
  };
}

function parseDomain(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return '';
  }
}

export function getClientProperties(): ClientProperties {
  const params = new URLSearchParams(window.location.search);

  return {
    userAgent: navigator.userAgent,
    screenHeight: screen.height,
    screenWidth: screen.width,
    currentUrl: window.location.href,
    referrer: document.referrer,
    referringDomain: parseDomain(document.referrer),
    language: navigator.language,
    utm: {
      utmSource: params.get('utm_source') ?? undefined,
      utmMedium: params.get('utm_medium') ?? undefined,
      utmCampaign: params.get('utm_campaign') ?? undefined,
      utmContent: params.get('utm_content') ?? undefined,
      utmTerm: params.get('utm_term') ?? undefined,
    },
  };
}
